import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";

export function ProtectedRoute({ children, requireSub = false }) {
  const { user, offline } = useAuth();
  const location = useLocation();

  if (user === null) return <Loader label="Carico il tuo spazio…" />;
  if (!user && offline)
    return (
      <div className="flex min-h-screen flex-col items-center justify-center px-8 text-center" data-testid="offline-screen">
        <p className="font-serif-el text-2xl font-semibold text-[#FAF9F6]">Servizio non raggiungibile</p>
        <p className="mt-2 text-[#A1A1AA]">Controlla la connessione. Il tuo account e i tuoi progressi sono al sicuro.</p>
        <button onClick={() => window.location.reload()} data-testid="offline-retry" className="btn-gold mt-6 rounded-full px-8 py-3 text-sm uppercase tracking-wide">Riprova</button>
      </div>
    );
  if (!user)
    return <Navigate to="/accedi" replace state={{ from: location.pathname + location.search }} />;
  if (requireSub && !user.subscription_active)
    return <Navigate to="/paywall" replace />;
  return children;
}
